import { SignInPayload } from '../../../modules/account/types';
import { AccountResponse } from '../../../modules/auth/types';
import { teacherSignIn } from '../../../modules/teacher/api';

export const signInUseCase = async (payload: SignInPayload): Promise<AccountResponse> => {
  return teacherSignIn(payload);
};